module.exports = __webpack_public_path__ + "static/garaaz-logo-dark-2fe881eeb6679e9023adcc591e962bcc.png";